var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"top-header"},[_c('page-title')],1),_c('sales-amount-list',{attrs:{"latest-sold-products":_vm.latestSoldProducts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }